<template>
    <div class="personal__form">
        <div class="personal__form-title">Профиль</div>
        <form @submit.prevent="debounce(validate)" class="form" method="post" name="change_info">
            <div class="form__inputs">
                <div class="custom-input">
                    <input @input="this.reset" autocomplete="off" class="custom-input__input" type="text" name="name"
                           v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 4)}"
                           v-model="name" placeholder="Введите ФИО">
                    <span v-if="errors.some(er => er.code === 4)" class="custom-input__error"></span>
                    <label class="custom-input__label">ФИО</label>
                </div>
            </div>
            <div class="form__inputs form__inputs--2">
                <div class="custom-input">
                    <input @paste.prevent="removeFirstDigit" autocomplete="off" @input="this.reset" class="custom-input__input"
                           type="text" name="phone"
                           v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 1)}"
                           v-model="phone" data-mask-phone placeholder="Введите телефон">
                    <span v-if="errors.some(er => er.code === 1)" class="custom-input__error"></span>
                    <label class="custom-input__label">Телефон</label>
                </div>
                <div class="custom-input">
                    <input @input="this.reset" autocomplete="off" class="custom-input__input" type="text" name="birthday"
                           v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 6)}"
                           v-model="birthday" data-mask-date placeholder="Введите дату">
                    <span v-if="errors.some(er => er.code === 6)" class="custom-input__error"></span>
                    <label class="custom-input__label">Дата рождения</label>
                </div>
                <div class="custom-input">
                    <input @input="this.reset" autocomplete="off" class="custom-input__input" type="text" name="email"
                           v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 5)}"
                           v-model="email" placeholder="Введите E-mail">
                    <span v-if="errors.some(er => er.code === 5)" class="custom-input__error"></span>
                    <label class="custom-input__label">E-mail</label>
                </div>
                <div style="display: none">
                    <vue-recaptcha
                        ref="recaptcha"
                        size="invisible"
                        :sitekey="this.site_key"
                        @verify="sendData"
                        @expired="onCaptchaExpired"
                    />
                </div>
            </div>
            <div class="default-checkbox">
                <input @input="this.reset" class="default-checkbox__input" type="checkbox" name="subscription"
                       :checked="user.subscription" v-model="subscription" id="id-5">
                <label class="default-checkbox__label" for="id-5">Уведомлять о новых статьях</label>
            </div>
            <input class="btn" name="sendInfo" type="submit" value="Сохранить изменения"/>
        </form>
    </div>
</template>

<script>
import recaptcha from "@/components/mixins/recaptcha";
import errors from "@/components/mixins/errors";
import tools from "@/components/mixins/tools";

export default {
    name  : "PersonalData",
    props : ['user'],
    mixins: [recaptcha, errors, tools],
    data() {
        return {
            name        : this.user.name,
            email       : this.user.email,
            phone       : this.user.phone,
            birthday    : this.user.birthday,
            subscription: this.user.subscription,
        }
    },
    methods: {
        sendData(recaptchaToken) {
            this.reset();
            let formData = new FormData();
            formData.append('token', recaptchaToken);
            formData.append('name', this.name);
            formData.append('email', this.email);
            formData.append('phone', this.phone);
            formData.append('birthday', this.birthday);
            formData.append('subscription', this.subscription);
            fetch("/api/user/update/", {
                method: 'POST',
                body  : formData
            }).then(response => response.json()).then(async resp => {
                if(resp.success !== true)
                {
                    let errs = JSON.parse(resp.message);
                    this.parse(errs);
                }
                else
                {
                    if(this.user.email === this.email)
                        window.toast.success('Личный кабинет', 'Изменения успешно сохранены.');
                    else
                    {
                        window.toast.success('Личный кабинет', 'Изменения успешно сохранены. ' +
                                                               'На вашу почту выслано письмо со ссылкой для подтверждения новой почты, ' +
                                                               'пожалуйста, перейдите по ссылке в письме.');
                        setTimeout(function() {
                            location.href = '/confirmation/';
                        }, 5000);
                    }
                }
            });
        },
    },
}
</script>

<style scoped>

</style>